
<script>
    import i18n from "../i18n";
    import simplebar from "simplebar-vue";
    import InputWithDropdown from "./SearchDropdown/InputWithDropdown";
    import UserMeta from "@/mixins/usermeta.mixin";

    import {Currencies} from "@/views/assetflow/form_data/Currencies";
    import {Timezones} from "@/views/assetflow/form_data/Timezones";

    import FileNotificationsDropdown from '@/components/FileNotificationsDropdown';
    import {discInitials} from "@/views/assetflow/form_data/discInitials";


    /**
     * Nav-bar Component
     */
    export default {
        mixins: [UserMeta],
        data() {
            return {
                item_type: '',
                languages: [
                    {
                        flag: "/images/flags/us.jpg",
                        language: "en",
                        title: "English",
                    },
                    {
                        flag: "/images/flags/french.jpg",
                        language: "fr",
                        title: "French",
                    },
                    {
                        flag: "/images/flags/spain.jpg",
                        language: "es",
                        title: "Spanish",
                    },
                    {
                        flag: "/images/flags/chaina.png",
                        language: "zh",
                        title: "Chinese",
                    },
                    {
                        flag: "/images/flags/arabic.png",
                        language: "ar",
                        title: "Arabic",
                    },
                ],
                lan: i18n.locale,
                text: null,
                flag: null,
                value: null,
                site_name: "",
                af_initials: '',
                main_logo: "/images/logo-dark.png",
                dark_logo: '/images/logo-dark.png',
                light_logo: '/images/logo-light.png',
                dark_logo_svg: '/images/logo.svg',
                light_logo_svg: '/images/logo-light.svg',
                item_name: '',
                user_info: {
                    id: null,
                    name: "AssetFlow",
                    can_switch_customer: false,
                    can_switch_sp: false,
                    can_switch_group: false
                },
                user_meta: {},

                modules_list:[],
                // current_currency: {
                //     value: 'gbp',
                //     text: "GBP",
                //     icon: '£'
                // },
                // currencies: Currencies,
                current_timezone: {
                    value: '+00:00',
                    text: "GMT"
                },
                timezones: Timezones,

                currencies: [],
                currenciesLoaded: false,
                current_currency: {
                    name: 'USD',
                    symbol: '$'
                },

            };
        },
        components: { InputWithDropdown, simplebar, FileNotificationsDropdown },
        created() {

            let url_segments = window.location.pathname.split('/');
            if (url_segments.length > 1){
                this.item_type = url_segments[1];
            }


            this.user_info = window.USER_INFO ?? this.user_info;

            if ( this.item_type === '' || this.item_type === 'af_dashboard'){
                let current_entity = this.user_info && this.user_info.hasOwnProperty('current_entity') ? this.user_info.current_entity : null;
                if (current_entity && current_entity.hasOwnProperty('entity_item_type') && current_entity.entity_item_type){
                    this.item_type = current_entity.entity_item_type;
                }
            }

            this.user_meta = this.user_info.user_meta ?? this.user_meta;

            this.site_name = (window.AF_NAME ? window.AF_NAME : (process.env.MIX_SITE_NAME ? process.env.MIX_SITE_NAME : 'Asset Flow'));
            this.af_initials = (window.AF_INITIALS ? window.AF_INITIALS : "");

            this.main_logo = (window.AF_LOGO ? window.AF_LOGO : this.main_logo) + '/inside/180/60';
            this.dark_logo = this.main_logo;
            this.light_logo = this.main_logo;
            this.dark_logo_svg = this.main_logo;
            this.light_logo_svg = this.main_logo;
        },
        beforeDestroy() {
            this.$root.$off('bv::dropdown::show', this.onDropdownShow);
        },
        mounted() {
            this.$root.$on('bv::dropdown::show', this.onDropdownShow);
        
            let saved_currency = this.user_info.preferred_currency_info ?? localStorage.getItem("current_currency");
            if(saved_currency){
                this.current_currency = saved_currency;
                this.fireLoadExchangeRates(saved_currency);
            }
            this.modules_list = window.MODULES_LIST ? window.MODULES_LIST : [];
            let saved_module = this.current_module ?? null;
            if (saved_module){
                let found_module = this.modules_list.find((x) => x.id === (saved_module.id));
                if (found_module){
                    this.current_module = found_module;
                }
            }


            let saved_timezone = this.user_meta.timezone ?? localStorage.getItem("current_timezone");
            let found_timezone = this.timezones.find((x) => x.value === saved_timezone);
            if (found_timezone){
                this.current_timezone = found_timezone;
            }

            this.value = this.languages.find((x) => x.language === i18n.locale);
            this.text = this.value.title;
            this.flag = this.value.flag;
        },
        methods: {
            onDropdownShow(bvEvent) {
                const id = bvEvent?.vueTarget?.$el?.id;
                if (id === 'currency-dropdown') {
                    this.loadCurrencies();
                }
            },
            loadCurrencies() {
                if (this.currenciesLoaded) return;

                axios.get('/api/assetflow/currencies')
                    .then(response => {
                        this.currencies = response.data;
                        this.currenciesLoaded = true;
                    })
                    .catch(error => {
                        console.error('Failed to fetch currencies:', error);
                    });
            },
            setCurrency(currency) {
                this.current_currency = currency;
                let message = "Saved New Currency {"+currency.name+"} Successfully";
                this.set_usermeta('currency', currency.id, message);
                this.fireLoadExchangeRates(currency);
                localStorage.setItem("current_currency", currency);
            },
            async fireLoadExchangeRates(currency){
                await this.loadExchangeRates(currency.code);
            },
            toggleMenu() {
                let use_icons = !this.$parent.isMenuCondensed ? true : 0;
                this.$parent.$refs.rightBar.setUseIcons(use_icons);
            },
            initFullScreen() {
                document.body.classList.toggle("fullscreen-enable");
                if (
                    !document.fullscreenElement &&
                    /* alternative standard method */ !document.mozFullScreenElement &&
                    !document.webkitFullscreenElement
                ) {
                    // current working methods
                    if (document.documentElement.requestFullscreen) {
                        document.documentElement.requestFullscreen();
                    } else if (document.documentElement.mozRequestFullScreen) {
                        document.documentElement.mozRequestFullScreen();
                    } else if (document.documentElement.webkitRequestFullscreen) {
                        document.documentElement.webkitRequestFullscreen(
                            Element.ALLOW_KEYBOARD_INPUT
                        );
                    }
                } else {
                    if (document.cancelFullScreen) {
                        document.cancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    }
                }
            },
            setLanguage(locale, country, flag) {
                this.lan = locale;
                this.text = country;
                this.flag = flag;
                i18n.locale = locale;
                localStorage.setItem("locale", locale);
            },
            setModule(module) {
                this.current_module = module;
                let message = "Saved New Module {"+module.name+"} Successfully";
                window.flash(message);
                // // shall redirect?
                // console.log("'shall redirect?'");
                // console.log('shall redirect?');
                // console.log("module");
                // console.log(module);


                this.set_usermeta('current_module', module.id, "", '/');
            },
            setTimezone(timezone) {
                this.current_timezone = timezone;
                let message = "Saved New Timezone {"+timezone.text+"} Successfully";
                this.set_usermeta('timezone', timezone.value, message);
                localStorage.setItem("current_timezone", timezone.value);
            },
            setLogoAndName(name, new_logo){
                this.light_logo = new_logo
                this.item_name = name
            }
        },
        computed:{
            required_item(){
                if (this.item_type === 'customer'){
                    return this.current_customer;
                }else if (this.item_type === 'sp'){
                    return this.current_sp;
                }
                return null;
            },
            /**
             * Entry 2 of the walk hand-off part 2 (unit XB), SHARED: the top bar's disc prints the current
             * entity's initials through the one disc helper, cleaned (upper case, letters and digits only)
             * and cut to at most THREE at its own 24px size, with no size step. '' keeps today's "AF" disc.
             */
            brand_initials() {
                return this.af_initials === '' ? '' : discInitials(this.af_initials, this.site_name, {max: 3, escape: false}).text;
            },
            /**
             * T34: the entity's own colours onto the `.ftd` element, which is how every other component
             * drawn from the approved sheet takes them (`FilmTvDashboard.vue:213-232`, the same four
             * keys in the same order). `window.COLOUR_PLATE` is emitted by `app.blade.php` only when the
             * entity has a primary colour, so `null` here leaves the sheet's own fall-back in place.
             * It adds no colour of its own: the four inline red values the demo
             * warning are one rule in `_topbar.scss` and the search group heading's inline colour is
             * another, both reading `--ftd-primary` rather than writing a colour into the markup.
             */
            theme_style() {
                const plate = (typeof window !== 'undefined' && window.COLOUR_PLATE) ? window.COLOUR_PLATE : null;

                if (!plate) {
                    return null;
                }

                const variables = {
                    '--ftd-primary': plate.primary_colour,
                    '--ftd-accent': plate.accent_colour,
                    '--ftd-primary-soft': plate.soft_primary_colour,
                    '--ftd-accent-soft': plate.soft_accent_colour,
                };
                const style = {};

                Object.keys(variables).forEach(function (name) {
                    if (variables[name]) {
                        style[name] = variables[name];
                    }
                });

                return Object.keys(style).length ? style : null;
            }
        }
    };
</script>

<!--
    T34. THE TOP BAR, THE ORDER OF TODAY RESTYLED. d8 OPTION B (Log #357, chosen against the
    recommendation), drawn at `walk/2026-09-18/mock/design-walk/r13-top-bar.html` and signed off at
    Log #371.

    NOTHING MOVES. The six right-hand controls are the six of today in today's order -- the phone
    search, the File Jobs bell, the module switcher, the currency picker, the time zone picker, the
    user menu -- on one shape and one height. No control is added, none is removed, and every gate
    that decides who sees a control is the gate of today.

    THE MARKUP INSIDE `.ftd` IS THE REFERENCE'S: the same elements, the same `ftd-r13-` classes, the
    same order as `r13-top-bar.html:71-88`. It is drawn by the one approved sheet T6a ships
    (`public/css/film-tv-dashboard.css`) plus the placement in
    `resources/sass/custom/structure/_topbar.scss`. This component ships no stylesheet and writes no
    colour: the demo warning's four inline reds and the search heading's
    `COLOUR_PLATE` colour are each ONE RULE in that partial now.

    FIVE THINGS r13 DOES NOT DRAW are here all the same, because they are on the bar and must keep
    working (task points 7 to 10): the demo-only warning and its modal, the module `custom_header`
    hatch, the open-orders strip, the switcher's "Choose Module" state and the bell with no count.
    For those the rule is today's words and today's gates in the foundation's vocabulary, and the
    reference's silence is not a removal.

    WHAT IS NOT TOUCHED and is not dead code to be tidied: the five-language list and `setLanguage`,
    `initFullScreen`, the commented-out currency block, `setLogoAndName` and the `<h4>` it feeds, and
    the currency picker's three defects -- the missing `code` in the default, the object written to
    `localStorage` and the read back in `mounted()`. "$ undefined" goes on appearing where it appears
    today. `setModule` still lands on `/`.
-->
<template>
    <header id="page-topbar" class="ftd" :style="theme_style">
        <div
            class="navbar-header ftd-r13-bar"
            :class="{'ftd-r13-bar--tall': current_module_info && current_module_info.hasOwnProperty('custom_header')}">

            <!-- LOGO. Drawn ONCE (r13 point 1), in the brand box at the head of the navigation's own
                 column, where today's box already is. Today's second copy bound the SAME `dark_logo`,
                 so it was not a light variant of anything. `logo`, `logo-lg` and `logo-sm` stay on the
                 elements because the collapsed sidebar swaps them (`_vertical.scss:194-201`), which is
                 not this task's file. THE BAR'S OWN LEFT GROUP THEREFORE STARTS AT THE HAMBURGER.
                 Entry 1 of the walk hand-off part 2 (unit XB), SHARED: an entity WITH a logo draws the logo
                 alone with the sidebar open; `ftd-r13-brand--logo` hides the mark through ONE rule in
                 `_topbar.scss` that loses to the collapsed sidebar and to the 992px block, so both keep
                 the disc alone. The test is the template's own `noimage.png` one, below. -->
            <div class="navbar-brand-box ftd-r13-brand" :class="{'ftd-r13-brand--logo': !dark_logo.includes('noimage.png')}">
                <a href="/" class="logo">
                    <span class="logo-sm ftd-r13-brand__mark">
                        <span v-if="brand_initials !== ''" class="ftd-avatar ftd-avatar--sm af-accent text-af-primary" :title="site_name">{{brand_initials}}</span>
                        <span v-else class="ftd-avatar ftd-avatar--sm af-accent text-white">AF</span>
                    </span>
                    <span v-if="!this.dark_logo.includes('noimage.png')" class="logo-lg ftd-r13-brand__word">
                        <img :src="this.dark_logo" :alt="this.site_name" />
                    </span>
                    <span v-else class="logo-lg ftd-r13-brand__word">
                        {{site_name}}
                    </span>
                </a>
            </div>

            <!-- `setLogoAndName` sets `item_name` and nothing in the repository calls it. Kept. -->
            <h4 v-if="this.item_name" class="ftd-r13-name">{{this.item_name}}</h4>

            <button
                id="vertical-menu-btn"
                type="button"
                class="ftd-iconbtn ftd-r13-burger"
                title="Menu"
                @click="toggleMenu"
            >
                <i class="bx bx-menu" aria-hidden="true"></i><span class="ftd-sr">Menu</span>
            </button>

            <!-- App Search. `d-none d-lg-block` goes: the bar's own container query gives the box up
                 and puts the search icon in the right-hand group in its place (r13 point 13). -->
            <div class="ftd-r13-search">
                <input-with-dropdown></input-with-dropdown>
            </div>

            <!-- THE DEMO-ONLY WARNING (task point 7). r13 does not draw it; this is today's markup,
                 today's words and today's `required_item.demo_only` gate. -->
            <div class="ftd-r13-mid" v-if="required_item && required_item.hasOwnProperty('demo_only') && required_item.demo_only">


                <div role="alert" class="customer-alert demo-entity-alert ftd-note ftd-r13-demo">
                    <i class="bx bx-error"></i>
                    <a id="show-btn" href="javascript:void(0);" @click="$bvModal.show('bv-modal-warning')">Demo Only. Click for Details.</a>
                </div>

                <b-modal
                    id="bv-modal-warning"
                    size="lg"
                    centered
                    hide-footer
                    modal-class="ftd"
                    content-class="ftd-modal ftd-modal--sm"
                    header-class="ftd-modal__head"
                    body-class="ftd-modal__body">
                    <template #modal-title>
                        <span class="ftd-modal__title"><i class="bx bx-error"></i> Demo Only</span>
                    </template>

                    <div class="ftd-confirm">
                        <div class="ftd-confirm__icon ftd-confirm__icon--warn ftd-r13-demo__mark">
                            <i class="bx bx-error"></i>
                        </div>

                        <h4 class="ftd-r13-demo__title">Demo Only!</h4>

                        <p class="ftd-confirm__what"> Please note: this {{ required_item.entity_type | titleizeToSingle }} ({{ required_item.name }}) is for Demo Purposes Only.</p>

                        <p class="ftd-confirm__what"><strong>Any changes you make will be lost.</strong></p>
                        <p class="ftd-confirm__what">Please contact your Account Manager if you would like to learn more.</p>

                        <div class="ftd-modal__foot ftd-modal__foot--right">
                            <button type="button" class="ftd-btn ftd-btn--block demo-ok-button ftd-r13-demo__ok" @click="$bvModal.hide('bv-modal-warning')">Ok</button>
                        </div>
                    </div>

                </b-modal>

            </div>

            <!-- THE MODULE'S OWN HEADER (task point 8). Still `v-html`, still the `v-else-if` sibling
                 of the orders strip, so a module that fills it still hides the strip. -->
            <div v-if="current_module_info && current_module_info.hasOwnProperty('custom_header')" class="ftd-r13-mid ftd-r13-hatch hide-mobile header-module-header" v-html="current_module_info.custom_header"></div>

            <!-- THE OPEN-ORDERS STRIP (task point 9). All four of today's sentences, both of today's
                 server gates (`SharedInfoComposer.php:530` and `:574`, read and not edited). On
                 Assets Film & TV as a customer it is simply absent, which is why r13 does not draw it.
                 Today's `alert-primary` at zero and `alert-warning` above is one modifier now. -->
            <div class="ftd-r13-mid hide-mobile header-orders-block" v-else-if="required_item && required_item.hasOwnProperty('open_orders_count')">
                <div v-if="item_type === 'customer'"
                     class="customer-alert ftd-r13-orders"
                     :class="required_item.open_orders_count === 0 ? '' : 'ftd-r13-orders--open'" role="alert">
                    <i class="bx bx-cart"></i>
                    <a v-if="required_item.open_orders_count === 0" :href="'/' + item_type + '/orders/storage_orders'">No orders awaiting confirmation</a>

                    <a v-else-if="required_item.open_orders_count === 1 && required_item.hasOwnProperty('latest_order')" :href="'/' + item_type + '/orders/' + required_item.latest_order.id + '/view'" ><strong>{{ required_item.latest_order.uid }}</strong> is awaiting confirmation. <strong>View This Order</strong></a>

                    <a v-else-if="required_item.open_orders_count > 1" :href="'/' + item_type + '/orders/storage_orders'"><strong>{{ required_item.open_orders_count }} Orders</strong> are awaiting confirmation. <strong>View Open Orders</strong></a>
                </div>

                <div v-else-if="item_type === 'sp' && required_item.hasOwnProperty('latest_order') && required_item.latest_order && required_item.latest_order.hasOwnProperty('order_info') && required_item.latest_order.order_info"
                     class="sp-alert ftd-r13-orders" role="alert">
                    <i class="bx bx-cart"></i>
                    <a :href="'/' + item_type + '/orders/' + required_item.latest_order.order_info.id + '/view'">Latest: {{ '(' + required_item.latest_order.order_info.uid + ') ' + getItemPostTitle(required_item.latest_order.order_info, required_item.latest_order.post_info, 'Order') }}</a>
                </div>
            </div>

            <!-- THE SIX CONTROLS, in today's order, on ONE shape at 32px (r13:74-81). Each menu hangs
                 from its own control inside a `.ftd-menuwrap`, and BootstrapVue's toggle carries the
                 `aria-expanded` the reference reads. The three middle controls keep `hide-mobile`,
                 drawn as `.ftd-r13-hidephone`. -->
            <div class="ftd-r13-right">

                <b-dropdown
                    class="ftd-menuwrap ftd-r13-phonesearchwrap header-search"
                    variant="black"
                    menu-class="ftd-r13-pop ftd-r13-pop--wide"
                    toggle-class="ftd-r13-ctl ftd-r13-ctl--icon ftd-r13-phonesearch"
                    right
                    no-caret
                >
                    <template v-slot:button-content>
                        <i class="bx bx-search-alt" aria-hidden="true"></i><span class="ftd-sr">Search</span>
                    </template>

                    <input-with-dropdown :mobile_only="true"></input-with-dropdown>
                </b-dropdown>

                <FileNotificationsDropdown :item_type="item_type"/>

                <!-- The switcher reads "Choose Module" when no module has been chosen (task point 10);
                     r13 draws it named, and that empty state is today's and is kept. -->
                <b-dropdown variant="white" right no-caret toggle-class="ftd-r13-ctl" menu-class="ftd-menu ftd-r13-menu" class="ftd-menuwrap ftd-r13-hidephone hide-mobile header-modules">
                    <template v-slot:button-content>
                        <i v-if="current_module.hasOwnProperty('name') && current_module.name && current_module.icon" :class="current_module.icon"></i>
                        <span v-if="current_module.hasOwnProperty('name') && current_module.name" class="ftd-r13-ctl__label">{{`${current_module.name}`}}</span>
                        <span v-else class="ftd-r13-ctl__label">Choose Module</span>
                        <i class="bx bx-chevron-down ftd-r13-ctl__caret"></i>
                    </template>
                    <b-dropdown-item
                        class="notify-item"
                        v-for="(module, m_key) in modules_list"
                        :key="m_key"
                        :value="current_module"
                        @click="setModule(module)"
                        :active="current_module.id === module.id"
                    >
                        <span class="align-middle" :class="{'text-af-accent' : current_module.id === module.id}">
                            <i v-if="module.icon" :class="module.icon"></i> {{`${module.name}`}}
                        </span>
                    </b-dropdown-item>
                </b-dropdown>


                <!-- The currency picker's three defects are drawn around, not fixed: the default has no
                     `code`, so this label still reads "$ undefined" before the first save. -->
                <b-dropdown
                    id="currency-dropdown"
                    variant="white"
                    right
                    no-caret
                    toggle-class="ftd-r13-ctl"
                    menu-class="ftd-menu ftd-r13-menu"
                    class="ftd-menuwrap ftd-r13-hidephone hide-mobile header-currencies"
                    >
                    <template v-slot:button-content>
                        <span class="ftd-r13-ctl__label">{{`${current_currency.symbol} ${current_currency.code}`}}</span>
                        <i class="bx bx-chevron-down ftd-r13-ctl__caret"></i>
                    </template>

                    <b-dropdown-item
                        class="notify-item text-center"
                        v-for="(currency, c_key) in currencies"
                        :key="c_key"
                        :value="currency"
                        @click="setCurrency(currency)"
                        :active="current_currency.name === currency.name"
                    >
                        <span class="align-middle" :class="{ 'text-af-accent': current_currency.name === currency.name }">{{`${currency.symbol} ${currency.code}`}}</span>
                    </b-dropdown-item>
                </b-dropdown>


                <b-dropdown variant="white" right no-caret toggle-class="ftd-r13-ctl" menu-class="ftd-menu ftd-r13-menu" class="ftd-menuwrap ftd-r13-hidephone hide-mobile header-timezones">
                    <template v-slot:button-content>
                        <i class="bx bx-time"></i>
                        <span class="ftd-r13-ctl__label">{{`${current_timezone.text}`}}</span>
                        <i class="bx bx-chevron-down ftd-r13-ctl__caret"></i>
                    </template>
                    <b-dropdown-item
                        class="notify-item"
                        v-for="(timezone, c_key) in timezones"
                        :key="c_key"
                        :value="current_timezone"
                        @click="setTimezone(timezone)"
                        :active="current_timezone.value === timezone.value"
                    >
                        <span class="align-middle" :class="{'text-af-accent' : current_timezone.value === timezone.value}">{{`${timezone.text}`}}</span>
                    </b-dropdown-item>
                </b-dropdown>


                <!-- THE USER MENU. A plain `.ftd-menu` with today's eight items, today's two dividers
                     and Logout in red, and EVERY ONE OF TODAY'S FIVE CONDITIONALS unchanged:
                     `can_bulk_update === 1`, `can_switch_customer`, `can_switch_sp`,
                     `can_switch_group`, `add_file_imports`. The Switch label still tests
                     `is_tv_film_asset`, which is the one already-module-aware string on this bar, and
                     every label is still its own `$t()` key. -->
                <b-dropdown right variant="black" no-caret toggle-class="ftd-r13-ctl ftd-r13-ctl--me" menu-class="ftd-menu ftd-r13-menu" class="ftd-menuwrap">
                    <template v-slot:button-content>
                        <img
                            class="ftd-avatar ftd-avatar--sm header-profile-user"
                            :src="user_info.avatar ? user_info.avatar : '/images/users/avatar-1.jpg'"
                            alt="Header Avatar"
                        />
                        <span class="ftd-r13-ctl__label">{{ user_info.name || "AssetFlow" }}</span>
                        <i class="bx bx-chevron-down ftd-r13-ctl__caret"></i>
                    </template>
                    <!-- item-->
                    <b-dropdown-item href="/af_dashboard">
                        <i class="bx bxs-home"></i>
                        {{ $t('navbar.dropdown.assetflow.dashboard') }}
                    </b-dropdown-item>

                    <b-dropdown-item href="/profile">
                        <i class="bx bx-user"></i>
                        {{ $t('navbar.dropdown.assetflow.profile') }}
                    </b-dropdown-item>

                    <b-dropdown-item href="/my_roles">
                        <i class="bx bx-user-check"></i>
                        {{ $t('navbar.dropdown.assetflow.my_roles') }}
                    </b-dropdown-item>

                    <b-dropdown-item v-if="user_info.can_bulk_update === 1" :href="'/' + (item_type === 'sp' ? 'sp' : 'customer') + '/bulk_updates/user'">
                        <i class="bx bx-history"></i>
                        {{ $t('navbar.dropdown.assetflow.bulk_updates') }}
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-item v-if="user_info.can_switch_customer" href="/customer/switch">
                        <i class="bx bx-transfer"></i>
                        {{ !is_tv_film_asset ? $t('navbar.dropdown.assetflow.switch_customer') : $t('navbar.dropdown.assetflow.switch_production')}}
                    </b-dropdown-item>

                    <b-dropdown-item v-if="user_info.can_switch_sp" href="/sp/switch">
                        <i class="bx bx-transfer"></i>
                        {{ $t('navbar.dropdown.assetflow.switch_sp') }}
                    </b-dropdown-item>

                    <b-dropdown-item v-if="user_info.can_switch_group" href="/group/switch">
                        <i class="bx bx-transfer"></i>
                        {{ $t('navbar.dropdown.assetflow.switch_group') }}
                    </b-dropdown-item>

                    <b-dropdown-item v-if="user_info.add_file_imports" :href="'/' + (item_type === 'sp' ? 'sp' : 'customer') + '/assets/upload_assets'">
                        <i class="bx bx-import"></i>
                        {{ $t('navbar.dropdown.assetflow.import_objects') }}
                    </b-dropdown-item>


                    <b-dropdown-divider></b-dropdown-divider>
                    <a href="/logout" class="dropdown-item is-danger">
                        <i class="bx bx-log-out"></i>
                        {{ $t('navbar.dropdown.assetflow.logout') }}
                    </a>
                </b-dropdown>


            </div>
        </div>
    </header>
</template>
